document.addEventListener("DOMContentLoaded", () => {

    const smoke = document.createElement("div");

    smoke.className = "labella-header-smoke";

    document.body.appendChild(smoke);

    setTimeout(() => {
        smoke.remove();
    }, 2400);

});


